import $ from 'jQuery';

const $window = $(window);
const debounceDelay = 250;

function toggleDotation() {
    if ($('.dotation__wrapper').hasClass('expanded')) {
        $('.dotation__wrapper').removeClass('expanded');
        $('.dotation__more').removeClass('rotate');
    } else {
        $('.dotation__wrapper').addClass('expanded');
        $('.dotation__more').addClass('rotate');
        setTimeout(function () {
            if ($('.dotation__more').hasClass('rotate')) {
                $('.dotation__more').addClass('smoothscroll');
            }
        }, 0);
    }
}

function highlight() {
    var offset = 250;
    var distanceToTop = $window.scrollTop();
    $('.dotation__row.active').removeClass('active');

    var highlightFirst = true;
    $('.dotation__row').each(function () {
        if ($(this).offset().top - distanceToTop < offset && $(this).offset().top + $(this).outerHeight() - distanceToTop > offset) {
            $(this).addClass('active');
            highlightFirst = false;
            return;
        }
    });

    if (highlightFirst) {
        $('.dotation__row').first().addClass('active');
    }
}

$(function () {
    highlight();
    $window.on('scroll', highlight);
    let timeout = false;
    $window.on('resize', function () {
        clearTimeout(timeout);
        timeout = setTimeout(highlight, debounceDelay);
    });
    $window.on('smoothscroll:end', function () {
        $('.dotation__more').removeClass('smoothscroll');
    });
    $('.dotation__more').on('click', toggleDotation);
});
